document.addEventListener('DOMContentLoaded', function () {
  /**
   * 🔹 Get the currently selected variant from <variant-picker> or <product-form>
   */
  function getCurrentVariant() {
    let data = null;

    // 1️⃣ Try to get JSON inside <variant-picker>
    const pickerJSON = document.querySelector('variant-picker script[type="application/json"]');
    if (pickerJSON) {
      try {
        data = JSON.parse(pickerJSON.textContent);
      } catch (e) {
        console.warn('[VariantGallery] Failed to parse JSON in <variant-picker>', e);
      }
    }

    // 2️⃣ Fallback: Try <product-form> (Tinker theme often uses this)
    if (!data || (!data.variants && !data.product)) {
      const form = document.querySelector('product-form');
      if (form && form.dataset.product) {
        try {
          data = JSON.parse(form.dataset.product);
        } catch (e) {
          console.warn('[VariantGallery] Failed to parse product-form dataset', e);
        }
      }
    }

    if (!data) {
      console.warn('[VariantGallery] No variant data found');
      return null;
    }

    // 3️⃣ Get variants array
    const variants = data.product?.variants || data.variants || [data];
    if (!Array.isArray(variants)) {
      console.warn('[VariantGallery] No valid variants array', data);
      return null;
    }

    // 4️⃣ Find current variant by selected hidden input
    const currentId = document.querySelector('[name="id"]')?.value;
    const variant = variants.find(v => v.id == currentId);
    if (!variant) {
      console.warn('[VariantGallery] Could not find variant for ID', currentId);
      return null;
    }

    return variant;
  }

  /**
   * 🔹 Reorder gallery based on variant’s color/material keyword
   */
  function reorderGalleryByColor() {
    const variant = getCurrentVariant();
    if (!variant) return;

    const title = variant.title?.toLowerCase() || '';
    const colorMatch = title.match(/(yellow gold|white gold|rose gold|silver|platinum|14k|18k|gold)/i);
    const colorKeyword = colorMatch ? colorMatch[0].toLowerCase() : title.split(' ')[0];

    // 🖼 Select gallery container (update these selectors if needed)
    const gallery = document.querySelector('.Product__Gallery, #MediaGallery, .product__media-list, .media-list, .product-media-thumbnails');
    if (!gallery) {
      console.warn('[VariantGallery] No gallery element found');
      return;
    }

    const items = Array.from(gallery.querySelectorAll('li, .product__media-item, .media, .Product__Gallery__Image'));
    const matchItems = [];
    const rest = [];

    items.forEach(item => {
      const img = item.querySelector('img');
      if (!img) return;
      const src = img.src.toLowerCase();
      const alt = (img.alt || '').toLowerCase();

      if (src.includes(colorKeyword) || alt.includes(colorKeyword)) {
        matchItems.push(item);
      } else {
        rest.push(item);
      }
    });

    // 🪄 Rebuild the gallery with matching items first
    gallery.innerHTML = '';
    [...matchItems, ...rest].forEach(el => gallery.appendChild(el));

    console.log(`[VariantGallery] Reordered images for color: ${colorKeyword}`);
  }

  // ▶ Run once on load
  reorderGalleryByColor();

  // ▶ Re-run when variant changes
  document.addEventListener('VariantUpdateEvent', reorderGalleryByColor);
  document.addEventListener('change', reorderGalleryByColor);
});
